import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Fieldset from '../fieldset';
import Field from '../field';
import Postcode from './postcode';

const Address = forwardRef(({ label, name, required, international }, ref) => (
  <Fieldset legend={label} hideLegend removeMarginBottom>
    {label && <h3>{label}</h3>}
    <Field
      name={`${name}[address1]`}
      ref={ref}
      label="Building and street"
      labelHiddenText="line 1 of 2"
      type="text-field"
      autoComplete="address-line1"
      required={required}
    />
    <Field
      name={`${name}[address2]`}
      ref={ref}
      labelHiddenText="Building and street line 2 of 2"
      type="text-field"
      autoComplete="address-line2"
    />
    <Field
      name={`${name}[city]`}
      ref={ref}
      label="Town or city"
      type="text-field"
      autoComplete="address-level2"
      required={required}
    />

    {international && (
      <Field
        name={`${name}[country]`}
        ref={ref}
        label="Country"
        type="text-field"
        autoComplete="country"
        required={required}
      />
    )}
    <Postcode
      name={`${name}[postcode]`}
      ref={ref}
      required={required}
      international={international}
    />
  </Fieldset>
));

Address.displayName = 'Address';

Address.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  international: PropTypes.bool,
};

export default Address;
